import { CanvasMovieClip } from './canvasMovieClip';
import { falsy } from '../util/util';

export class FullSizeCanvas {
    constructor(options) {
        const _ = this;

        _.option = Object.assign(
            {
                $parent: null,
                canvasClass: 'canvas',
                width: 1280,
                height: 1024,
                alignX: 'center',
                alignY: 'center',
                spriteObj: null,
                onFinish: null
            },
            options
        );

        _.$parent = _.option.$parent;

        _.$canvas = null;

        _.canvas = null;

        _.ctx = null;

        _.$proxyResize = $.proxy(_.resize, _);

        _.animationFrame = null;

        _.isPlaying = true;

        _.spriteObj = _.option.spriteObj;

        _.movieClip = null;
    }

    // public methods
    restart() {
        const _ = this;

        _.isPlaying = true;

        _.movieClip.reset();

        _.loopAnimation();

        return _;
    }

    show(flag) {
        const _ = this;

        flag ? _.$parent.show() : _.$parent.hide();

        return _;
    }

    init(obj) {
        const _ = this;

        _.setInstance();

        return _;
    }

    setInstance() {
        const _ = this,
            opt = _.option;

        _.$canvas = $(_.getCanvasTpl()).css({ position: 'absolute' });
        _.$parent.append(_.$canvas);

        _.canvas = _.$canvas.get(0);
        _.ctx = _.canvas.getContext('2d');

        _.movieClip = new CanvasMovieClip({
            ctx: _.ctx,
            img: _.spriteObj.img,
            width: _.spriteObj.width,
            height: _.spriteObj.height,
            frameNum: _.spriteObj.frameNum,
            fps: _.spriteObj.fps,
            isLoop: _.spriteObj.isLoop,
            finishCallback: () => {
                _.isPlaying = false;

                opt.onFinish.call(null);
            }
        });

        const size = _.getImageSizeAspectFill();
        _.setCanvasSize(size.width, size.height);
        _.setWrapAlign(opt.alignX, opt.alignY, size);

        $(window).on('resize', _.$proxyResize);
        _.resize();

        _.loopAnimation();
    }

    resize(evt) {
        let _ = this,
            size = _.getImageSizeAspectFill(); // _.getCanvasSizeWidthFit();

        _.setCanvasSize(size.width, size.height);
        _.setWrapAlign(_.option.alignX, _.option.alignY, size);
    }

    loopAnimation() {
        let _ = this;

        if (falsy(_.isPlaying)) {
            window.cancelAnimationFrame(_.animationFrame);
            return;
        }

        _.animationFrame = window.requestAnimationFrame(
            _.loopAnimation.bind(_)
        );

        _.update();
    }

    update() {
        this.drawCanvas();
    }

    drawCanvas() {
        const _ = this,
            size = _.getImageSizeAspectFill();

        _.ctx.clearRect(0, 0, _.canvas.width, _.canvas.height);

        _.movieClip.render(size);
    }

    setCanvasSize(width, height) {
        const _ = this;

        _.ctx.canvas.width = width;
        _.ctx.canvas.height = height;

        _.$canvas.attr({ width: width, height: height });
    }

    setWrapAlign(alignX, alignY, modifiedSize) {
        let winWidth = window.innerWidth,
            winHeight = window.innerHeight,
            left = 0,
            top = 0;

        switch (alignX) {
            case 'left':
                left = 0;
                break;

            case 'center':
                left = Math.round((winWidth - modifiedSize.width) / 2);
                break;

            case 'right':
                left = Math.round(winWidth - modifiedSize.width);
                break;
        }

        switch (alignY) {
            case 'top':
                top = 0;
                break;

            case 'center':
                top = Math.round((winHeight - modifiedSize.height) / 2);
                break;

            case 'bottom':
                top = Math.round(winHeight - modifiedSize.height);
                break;
        }

        this.setCanvasPos({ left: left, top: top });
    }

    setCanvasPos(css) {
        this.$canvas.css(css);
    }

    getImageSizeAspectFill() {
        let _ = this,
            opt = _.option;

        let winWidth = window.innerWidth,
            winHeight = window.innerHeight,
            modifiedSizeW = winWidth,
            modifiedSizeH = Math.ceil((winWidth / opt.width) * opt.height);

        if (modifiedSizeH < winHeight) {
            modifiedSizeW = Math.ceil((winHeight / opt.height) * opt.width);
            modifiedSizeH = winHeight;
        }

        return {
            width: modifiedSizeW,
            height: modifiedSizeH
        };
    }

    getCanvasTpl() {
        return `<canvas class="${this.option.canvasClass}"></canvas>`;
    }
}
